import axios from "axios";

import {
  url_24,
  url_25,
  url_26,
  url_27,
  url_81,
  url_85,
  url_86,
  url_87,
  url_174,
  url_175,
  url_212,
} from "../../../../custom_utilities/api_services";
import {
  buildTopicExerciseSavePayload,
  getExerciseApiPayload,
  resolveExercisePaperId,
} from "../../../../containers/logged_user_components/evaluation_components/exercise_related_components/exercise_Test_component/exerciseTest_content_component/exercisePaperIdUtils";
import { getExerciseAnswerTypeId } from "../utils/exerciseExamUtils";

export const EXERCISE_FLOW = "exercise";
export const DPP_FLOW = "dpp";
export const PYQ_FLOW = "pyq";

export const resolveFlowType = (locationState, pathname) => {
  if (locationState?.type) return locationState.type;
  const path = String(pathname || "").toLowerCase();
  if (path.includes("pyq")) return PYQ_FLOW;
  if (path.includes("dpp")) return DPP_FLOW;
  return EXERCISE_FLOW;
};

// NEET targets always request the "neet" paper format regardless of the
// format stored on the selected PYQ card.
const resolvePyqFormat = ({ testDetails, userPreference, jeeMainOrAdvance }) => {
  if (Number(userPreference?.targetDetails?.[0]?.target_id) === 3) {
    return "neet";
  }

  const rawFormat =
    testDetails?.format || testDetails?.paper_format || jeeMainOrAdvance || null;

  return typeof rawFormat === "string" ? rawFormat.toLowerCase() : rawFormat;
};

export const fetchFlowQuestionList = async ({
  testType,
  testDetails,
  userPreference,
  topicData,
  jeeMainOrAdvance,
}) => {
  if (testType === PYQ_FLOW) {
    const response = await axios.post(url_86, {
      topic: testDetails?.topic_name,
      format: resolvePyqFormat({ testDetails, userPreference, jeeMainOrAdvance }),
    });

    const questions = response.data?.data;
    if (!Array.isArray(questions)) {
      return { ok: false, message: response.data?.message };
    }

    return {
      ok: true,
      questions,
      usedTime: Number(response.data?.total_time) || 0,
      paperId: questions[0]?.paper_id ?? testDetails?.paper_id ?? null,
    };
  }

  const requestPayload = {
    excersie_type: testDetails?.excersie_type,
    course_id: userPreference?.courseDetails?.[0]?.course_id,
    topic_id: topicData?.topicId,
  };
  if (testType === DPP_FLOW) {
    requestPayload.video_id = testDetails?.videoId;
  }

  const response = await axios.post(
    testType === DPP_FLOW ? url_24 : url_26,
    requestPayload
  );

  if (response.data?.status !== 200) {
    return { ok: false, message: response.data?.message };
  }

  const apiRoot = response.data;
  const apiPayload = getExerciseApiPayload(apiRoot);

  return {
    ok: true,
    questions: apiPayload?.AllQuestionList || [],
    usedTime: Number(apiRoot?.total_time) || 0,
    paperId: resolveExercisePaperId(
      testDetails,
      apiPayload?.AllQuestionList,
      apiPayload,
      apiRoot
    ),
  };
};

export const saveFlowQuestion = async ({
  testType,
  testDetails,
  question,
  userPreference,
  topicData,
  userData,
}) => {
  if (!question) return;

  if (testType === PYQ_FLOW) {
    const isIntegerAnswer = getExerciseAnswerTypeId(question) === 3;
    const selectedOptionIds = (question.userAnswerCollection || []).map(
      (answer) => answer.option_id
    );

    await axios.post(url_87, {
      negative_marks: question.negative_marks,
      partial_marks: question.partial_marks,
      positive_marks: question.positive_marks,
      qid: question.qid,
      subject: question.subject,
      time: question.totalTimeTaken,
      topic_name: question.topic_name,
      toughness: question.toughness,
      ...(isIntegerAnswer
        ? { option_int: question.integer_answer || "" }
        : { option_id: selectedOptionIds }),
    });
    return;
  }

  const payload = buildTopicExerciseSavePayload({
    testDetails,
    question,
    userPreference,
    topicData,
    userData,
    testType,
    calculatedTime: question.totalTimeTaken,
  });

  await axios.post(testType === DPP_FLOW ? url_25 : url_27, payload);
};

export const submitPyqPaper = async (paperId, time) => {
  const response = await axios.post(url_81, { paper_id: paperId, time });
  return response.data?.status === 200;
};

export const fetchPyqSingleQuestion = async (paperId, qid) => {
  const response = await axios.post(url_212, {
    paper_id: paperId,
    qid,
  });

  if (response.data?.status !== 200) {
    return null;
  }

  const payload = response.data?.data;
  if (Array.isArray(payload)) {
    return payload[0] || null;
  }

  return payload || null;
};

export const fetchPyqInstructions = async (topicName) => {
  const response = await axios.post(url_85, { topic_name: topicName });
  if (response.data?.status === 200) {
    return response.data.data;
  }
  return null;
};

export const fetchSubmissionCoins = async ({
  testType,
  testDetails,
  userPreference,
  topicData,
  userData,
}) => {
  const response = await axios.post(url_174, {
    type: testType === DPP_FLOW ? "Attending_DPP" : "Attending_EXERCISE",
    paper_type: testType === DPP_FLOW ? "DPP" : "Exercise",
    exercise_type: testDetails?.excersie_type,
    course_id: userPreference?.courseDetails?.[0]?.course_id,
    topic_id: topicData?.topicId,
    video_id: testDetails?.videoId,
    user_id: userData?.user_id,
  });

  if (
    response.data?.status === 200 &&
    response.data.data !== "MCoins Already Credited...!"
  ) {
    return response.data.data;
  }

  return null;
};

export const fetchCoinUsesPoints = async () => {
  const response = await axios.get(url_175);
  if (response.data?.status === 200) {
    return [...response.data.data];
  }
  return [];
};
